import { ReferenceLine } from 'recharts'
import BirthdaySvg from '../_svgs/birthday.svg?react'
import GraduationSvg from '../_svgs/graduation.svg?react'
import MarriageSvg from '../_svgs/marriage.svg?react'

interface Props {
  maxAbs: number
}

export const ChildrenMilestones = ({ maxAbs }: Props) => {
  const birthDayLinePosition = 18 * 12
  const graduationsLinePosition = 25 * 12
  const marriageLinePosition = 30 * 12

  return (
    <>
      <ReferenceLine
        stroke="#FF7B47"
        strokeWidth={1}
        strokeDasharray="2 2"
        segment={[
          { x: birthDayLinePosition, y: 0 },
          { x: birthDayLinePosition, y: maxAbs * 0.3 },
        ]}
        label={{
          value: '',
          position: 'top',
          content: (props: any) => {
            const { viewBox } = props
            if (!viewBox) return null

            // Vypočítaj pozíciu na polovici grafu
            const midPoint = viewBox.y + viewBox.height / 2

            return (
              <g>
                <foreignObject
                  x={viewBox.x - 17}
                  y={midPoint - 70} // Ikona začína od konca čiary
                  width="34"
                  height="38">
                  <BirthdaySvg />
                </foreignObject>
              </g>
            )
          },
        }}
      />
      <ReferenceLine
        stroke="#0077FF"
        strokeWidth={1}
        strokeDasharray="2 2"
        segment={[
          { x: graduationsLinePosition, y: 0 },
          { x: graduationsLinePosition, y: maxAbs * 0.5 },
        ]}
        label={{
          value: '',
          position: 'top',
          content: (props: any) => {
            const { viewBox } = props
            if (!viewBox) return null

            // Vypočítaj pozíciu na polovici grafu
            const midPoint = viewBox.y + viewBox.height / 2

            return (
              <g>
                <foreignObject
                  x={viewBox.x - 17}
                  y={midPoint - 90} // Ikona začína od konca čiary
                  width="34"
                  height="38">
                  <GraduationSvg />
                </foreignObject>
              </g>
            )
          },
        }}
      />
      <ReferenceLine
        stroke="#A370FF"
        strokeWidth={1}
        strokeDasharray="2 2"
        segment={[
          { x: marriageLinePosition, y: 0 },
          { x: marriageLinePosition, y: maxAbs * 0.65 },
        ]}
        label={{
          value: '',
          position: 'top',
          content: (props: any) => {
            const { viewBox } = props
            if (!viewBox) return null

            // Vypočítaj pozíciu na polovici grafu
            const midPoint = viewBox.y + viewBox.height / 2

            return (
              <g>
                <foreignObject
                  x={viewBox.x - 17}
                  y={midPoint - 110} // Ikona začína od konca čiary
                  width="34"
                  height="38">
                  <MarriageSvg />
                </foreignObject>
              </g>
            )
          },
        }}
      />
    </>
  )
}
